import request from '@/utils/request';

// 获取开票历史记录列表
export function queryInvoiceHistoryPageList(data) {
  return request({
    url: '/invoice/history/queryInvoiceHistoryPageList',
    method: 'POST',
    data
  });
}
// 分页获取开票历史订单记录列表
export function queryUserInvoiceHistoryOrderPageList(data) {
  return request({
    url: '/invoice/history/order/queryUserInvoiceHistoryOrderPageList',
    method: 'POST',
    data
  });
}
// 订单导出Excel-导出开票历史记录
export function orderExportExcel(data) {
  return request({
    url: '/invoice/history/exportInvoiceHistory',
    method: 'POST',
    data,
    responseType: 'blob'
  });
}



// WEBPACK FOOTER //
// ./src/api/invoice.js